import { useIntl } from 'react-intl';
import cx from 'clsx';
import { SkeletonLoader } from '@repo/design-system-kit/components/skeleton-loader/skeleton-loader';
import styles from './idnow-loading.module.css';

function CardSkeleton() {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <SkeletonLoader.Block style={{ width: '80px', height: '80px', borderRadius: '8px' }} />
        <SkeletonLoader.Line style={{ width: '180px' }} />
      </div>

      <div className={styles.cardContent}>
        <div className={styles.cardItem}>
          <div className={styles.cardItemTitle}>
            <SkeletonLoader.Block style={{ width: '24px', height: '24px', borderRadius: '4px' }} />
            <SkeletonLoader.Line style={{ width: '100px' }} />
            <SkeletonLoader.Block style={{ width: '60px', height: '24px', borderRadius: '12px' }} />
          </div>
          <SkeletonLoader.Line style={{ width: '100%' }} />
          <SkeletonLoader.Line style={{ width: '80%' }} />
        </div>

        <div className={styles.cardDivider}>
          <div className={styles.cardDividerLine} />
          <SkeletonLoader.Line style={{ width: '32px' }} />
          <div className={styles.cardDividerLine} />
        </div>

        <div className={styles.cardItem}>
          <div className={styles.cardItemTitle}>
            <SkeletonLoader.Block style={{ width: '24px', height: '24px', borderRadius: '4px' }} />
            <SkeletonLoader.Line style={{ width: '100px' }} />
          </div>
          <SkeletonLoader.Line style={{ width: '100%' }} />
        </div>
      </div>

      <SkeletonLoader.Block style={{ width: '100%', height: '40px', borderRadius: '4px' }} />
    </div>
  );
}

export function IdnowLoading({ isFullHeight = true }: { isFullHeight?: boolean }) {
  const { formatMessage } = useIntl();

  return (
    <div
      aria-label={formatMessage({
        id: 'generic.loading-screen.title',
        defaultMessage: 'Just a few seconds...',
      })}
      className={cx(styles.container, isFullHeight && styles.fullHeight)}
      data-testid="idnow-loading"
      role="status"
    >
      <div className={styles.header}>
        <SkeletonLoader.Header style={{ width: '400px' }} />
        <div className={styles.headerText}>
          <SkeletonLoader.Line style={{ width: '100%' }} />
          <SkeletonLoader.Line style={{ width: '100%' }} />
          <SkeletonLoader.Line style={{ width: '60%' }} />
        </div>
      </div>

      <div className={styles.cards}>
        <CardSkeleton />
        <CardSkeleton />
      </div>
    </div>
  );
}
